import React from "react";

function Icon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="70"
      height="70"
      viewBox="0 0 70 70"
      fill="none"
    >
      <g clipPath="url(#clip0_6007_3964)">
        <path
          d="M57.2086 -0.130859H48.4603L35.3379 9.71097L39.4797 12.8139C39.9786 12.6704 40.457 12.4311 40.8808 12.1167L57.2086 -0.130859Z"
          fill="#1C6543"
        />
        <g filter="url(#filter0_d_6007_3964)">
          <path
            d="M13.1289 10.9491V59.0647C13.1289 61.4773 15.0904 63.4388 17.5031 63.4388H52.4962C54.9088 63.4388 56.8704 61.4773 56.8704 59.0647V10.9491C56.8704 8.53648 54.9088 6.57495 52.4962 6.57495H17.5031C15.0904 6.57495 13.1289 8.53648 13.1289 10.9491ZM45.935 15.3232H24.0643C22.8545 15.3232 21.8772 14.3459 21.8772 13.1362C21.8772 11.9264 22.8545 10.9491 24.0643 10.9491H45.935C47.1447 10.9491 48.1221 11.9264 48.1221 13.1362C48.1221 14.3459 47.1447 15.3232 45.935 15.3232Z"
            fill="url(#paint0_linear_6007_3964)"
          />
          <path
            d="M13.4089 59.0647V10.9491C13.4089 8.69112 15.2451 6.85495 17.5031 6.85495H52.4962C54.7542 6.85495 56.5904 8.69112 56.5904 10.9491V59.0647C56.5904 61.3227 54.7542 63.1588 52.4962 63.1588H17.5031C15.2451 63.1588 13.4089 61.3227 13.4089 59.0647ZM24.0643 15.6032H45.935C47.2994 15.6032 48.4021 14.5005 48.4021 13.1362C48.4021 11.7718 47.2994 10.6691 45.935 10.6691H24.0643C22.6999 10.6691 21.5972 11.7718 21.5972 13.1362C21.5972 14.5005 22.6999 15.6032 24.0643 15.6032Z"
            stroke="url(#paint1_linear_6007_3964)"
            stroke-opacity="0.8"
            strokeWidth="0.56"
          />
        </g>
        <mask
          id="mask0_6007_3964"
          style={{ maskType: "alpha" }}
          maskUnits="userSpaceOnUse"
          x="13"
          y="6"
          width="45"
          height="58"
        >
          <rect
            x="13.417"
            y="6.41663"
            width="43.75"
            height="57.1667"
            fill="#D9D9D9"
          />
        </mask>
        <g mask="url(#mask0_6007_3964)">
          <path
            d="M53.4173 42.875C53.4173 46.0465 51.1258 48.969 47.3087 51.1128C43.4996 53.2522 38.2204 54.5833 32.3757 54.5833C26.5309 54.5833 21.2517 53.2522 17.4426 51.1128C13.6255 48.969 11.334 46.0465 11.334 42.875C11.334 39.7034 13.6255 36.7809 17.4426 34.6371C21.2517 32.4977 26.5309 31.1666 32.3757 31.1666C38.2204 31.1666 43.4996 32.4977 47.3087 34.6371C51.1258 36.7809 53.4173 39.7034 53.4173 42.875Z"
            stroke="white"
            stroke-opacity="0.2"
            strokeWidth="0.5"
          />
        </g>
        <ellipse
          cx="32.6667"
          cy="43.1666"
          rx="11.6667"
          ry="3.5"
          fill="#1C6543"
          fill-opacity="0.3"
        />
        <path
          d="M24.147 51.4536C24.2668 51.4481 24.3702 51.4726 24.4573 51.5271C24.5444 51.5761 24.6206 51.6604 24.686 51.7802L26.4255 54.8509L25.4781 54.9652L24.0326 52.2539H22.1706L20.1453 54.9407L19.1816 54.8264L21.501 51.7557C21.5826 51.6414 21.6643 51.5624 21.746 51.5189C21.8276 51.4699 21.9311 51.4481 22.0563 51.4536H24.147ZM23.3548 53.5769L22.775 58.3544H21.9093L22.4891 53.5769H23.3548Z"
          fill="#196240"
        />
        <path
          d="M31.7828 51.3311C31.712 51.8864 31.6086 52.439 31.4725 52.9889C31.7665 53.9907 32.1612 54.8999 32.6566 55.7166C33.1521 56.5278 33.751 57.2682 34.4533 57.9379L33.5468 58.3136C33.0459 57.8018 32.5777 57.1974 32.1421 56.5006C31.712 55.8037 31.35 55.0605 31.056 54.2711C30.4135 55.8881 29.4281 57.241 28.0996 58.3299L27.2176 57.9624C28.2466 57.1022 29.066 56.1385 29.6758 55.0714C30.3183 53.9281 30.7157 52.6813 30.8681 51.3311H31.7828Z"
          fill="#196240"
        />
        <path
          d="M40.7008 53.0787C40.8043 54.0805 41.022 54.9952 41.3541 55.8227C41.6645 56.5849 42.0919 57.3199 42.6363 58.0277L41.8605 58.3136C41.5284 57.8998 41.2316 57.3962 40.9703 56.8027C40.6926 56.2038 40.4721 55.5668 40.3088 54.8917C40.091 55.5777 39.8079 56.2283 39.4595 56.8436C39.1165 57.4588 38.7463 57.9597 38.3488 58.3462L37.5321 58.0686C38.1474 57.5187 38.6755 56.7646 39.1165 55.8064C39.307 55.3872 39.4649 54.9598 39.5901 54.5242C39.7208 54.0832 39.8134 53.664 39.8678 53.2666L40.1128 51.3882H40.9131L40.7008 53.0787ZM36.446 51.4617L38.2508 52.1722L38.1365 53.0052L36.3398 52.2947L36.446 51.4617ZM37.1728 56.5087C37.1674 56.5251 37.1646 56.5441 37.1646 56.5659C37.1646 56.5877 37.1755 56.5986 37.1973 56.5986C37.2191 56.5986 37.249 56.5877 37.2871 56.5659C37.592 56.4026 37.9078 56.1902 38.2345 55.9289L38.3406 56.7619C38.0085 57.0123 37.6655 57.2356 37.3116 57.4316C37.1265 57.5404 36.9578 57.5949 36.8053 57.5949C36.7073 57.5949 36.6256 57.5704 36.5603 57.5214C36.4188 57.4288 36.348 57.2682 36.348 57.0396C36.348 56.996 36.3534 56.9252 36.3643 56.8272L36.7236 54.1241H35.7191L35.809 53.3564H37.083C37.2463 53.3564 37.3661 53.3999 37.4423 53.4871C37.5185 53.5687 37.5485 53.6858 37.5321 53.8382L37.1728 56.5087Z"
          fill="#196240"
        />
        <path
          d="M44.5473 51.4209L46.197 52.1396L46.0826 52.9644L44.4411 52.2457L44.5473 51.4209ZM46.736 51.7231H50.8275L50.754 52.4826H49.4963L49.2676 54.3201H50.5661L50.4763 55.0714H49.1778L48.8838 57.3907H50.6641L50.5906 58.1666H45.805L45.8866 57.3907H46.4828L46.9401 53.6504H47.7241L47.2668 57.3907H48.0671L48.6796 52.4826H46.6543L46.736 51.7231ZM45.266 56.6231V56.6394C45.266 56.6884 45.2823 56.7129 45.315 56.7129C45.3259 56.7129 45.3476 56.702 45.3803 56.6802C45.7288 56.3917 46.0091 56.1521 46.2215 55.9616L46.3031 56.8681C46.0091 57.1131 45.7097 57.339 45.4048 57.5459C45.2306 57.6657 45.0645 57.7256 44.9066 57.7256C44.8359 57.7256 44.7624 57.7065 44.6861 57.6684C44.5228 57.5758 44.4411 57.4125 44.4411 57.1784C44.4411 57.1457 44.4466 57.0858 44.4575 56.9987L44.8168 54.1159H43.845L43.9348 53.3646H45.1516C45.315 53.3646 45.4402 53.4108 45.5273 53.5034C45.6144 53.5959 45.6471 53.7157 45.6253 53.8627L45.266 56.6231Z"
          fill="#196240"
        />
        <g filter="url(#filter1_d_6007_3964)">
          <path
            d="M22.1575 -0.130859H13.4092L29.7439 12.1167C30.1676 12.4311 30.6392 12.6704 31.145 12.8139C31.5345 12.9301 31.9378 12.9847 32.3479 12.9916H38.1983C38.6152 12.9916 39.0253 12.9301 39.4217 12.8139L22.1575 -0.130859Z"
            fill="#B9F5D9"
          />
        </g>
        <path
          d="M47.5317 26.4443L34.1259 18.7045C32.4208 17.72 30.2359 18.2909 29.2636 19.9749L22.7653 31.2303C21.7931 32.9142 22.3912 35.0919 24.0963 36.0764L37.502 43.8162C39.2072 44.8006 41.3921 44.2298 42.3644 42.5458L48.8627 31.2904C49.8349 29.6064 49.2368 27.4287 47.5317 26.4443ZM34.749 25.1161C35.729 25.6819 36.0617 26.8934 35.503 27.8612C34.9442 28.829 33.7286 29.1466 32.7487 28.5808C31.7687 28.0151 31.436 26.8036 31.9947 25.8358C32.5535 24.868 33.7691 24.5504 34.749 25.1161ZM29.9605 33.4101C27.8928 32.2163 26.2185 31.3142 27.1852 29.64C28.1518 27.9657 30.5972 27.5322 32.6649 28.726C34.7326 29.9198 35.5855 32.2446 34.6132 33.9285C33.613 35.6609 32.0282 34.6039 29.9605 33.4101ZM40.6507 36.9368L38.0244 35.4205C37.456 35.0924 37.3071 34.3999 37.6032 33.887C37.9273 33.3256 38.6225 33.1851 39.1419 33.485L41.7682 35.0012C42.3366 35.3294 42.4855 36.0219 42.1894 36.5348C41.8653 37.0961 41.2191 37.265 40.6507 36.9368ZM42.4722 33.7818L38.5524 31.5187C37.984 31.1906 37.8351 30.4981 38.1312 29.9851C38.4553 29.4238 39.1505 29.2833 39.6699 29.5831L43.5897 31.8462C44.1581 32.1744 44.3071 32.8669 44.0109 33.3798C43.7638 33.921 43.0406 34.11 42.4722 33.7818Z"
          fill="url(#paint2_linear_6007_3964)"
          fill-opacity="0.9"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_6007_3964"
          x="8.12891"
          y="3.57495"
          width="53.7412"
          height="66.8639"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="2" />
          <feGaussianBlur stdDeviation="2.5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0783854 0 0 0 0 0.100868 0 0 0 0 0.145833 0 0 0 0.62 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_6007_3964"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_6007_3964"
            result="shape"
          />
        </filter>
        <filter
          id="filter1_d_6007_3964"
          x="11.4092"
          y="-0.130859"
          width="30.0127"
          height="17.1224"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="2" />
          <feGaussianBlur stdDeviation="1" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0433333 0 0 0 0 0.133333 0 0 0 0 0.0910257 0 0 0 0.16 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_6007_3964"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_6007_3964"
            result="shape"
          />
        </filter>
        <linearGradient
          id="paint0_linear_6007_3964"
          x1="34.9999"
          y1="6.41673"
          x2="34.9996"
          y2="63.4388"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#5DC293" />
          <stop offset="1" stopColor="#7BB8B4" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_6007_3964"
          x1="15.1666"
          y1="7.87506"
          x2="55.1249"
          y2="62.7084"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9AEBC5" />
          <stop offset="1" stopColor="#86CBAB" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_6007_3964"
          x1="33.1596"
          y1="18.1466"
          x2="38.4669"
          y2="45.6197"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.414802" stopColor="#DEEFE7" />
          <stop offset="1" stopColor="#E1F3EB" stop-opacity="0.65" />
        </linearGradient>
        <clipPath id="clip0_6007_3964">
          <rect width="70" height="70" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default Icon;
